import { Pipe, PipeTransform } from '@angular/core';
import { VerticalType } from '../enum/vertical-type/verticalType.enum';
import { VERTICAL_LABEL_KEY } from '../enum/vertical-type/vertical-lab.map';

@Pipe({ name: 'verticalName', standalone: true })
export class VerticalNamePipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) return '';
    const key = VERTICAL_LABEL_KEY[value as VerticalType];
    return key ? `enums.verticals.${key}` : '';
  }
}
